const $ = window.jQuery;
const $window = window.$window || $(window);

/**
 * Fade out the pop up banner of the current slide
 */
const GetApiData = {

    // 1. describe and create/initiate our object
    init() { 
        // this.resultsDiv = $('#product-overlay__results');
        this.openButton = $('.select-area__dots > div');
        this.closeButton = $('.pop-return--wrapper');
        this.events();
        // this.getResults();
    },

    // 2. events
    events() {
        this.openButton.on('click', this.getResults);
        this.openButton.on('click', this.openOverlay);
        this.closeButton.on('click', this.closeOverlay);
    },

    // 3. methods (function, action..)
    openOverlay() {
        
        // Set the Background Image
        var dataImage = $(this).attr("data-image");
        $('.popup-banner').css("background", "url(" + dataImage + ") left center no-repeat");

        // Set the Title
        var dataName = $('.area-name', this).text();
        $('.area-heading').html(dataName);

        // Set the Width
        $('.home-hero__wrapper').css({
            "min-width": "100%",
            "overflow": "hidden"
        });

        // Hide dots from shifting into view
        $('.select-area__dots > div, .flash').css('display', 'none');

        // Fade in Popup
        $('.popup-banner').fadeIn( "slow" );

        // Insert Loader
        $('#product-overlay__results').html(`
            <div class="carousel-loading flex justify-center items-center rounded">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-guard-red" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="rgba(243, 244, 246,1)" stroke-width="4"></circle>
                    <path fill="#7e2520" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Loading...</span>
            </div>
        `)
    },

    closeOverlay() {
        $('.popup-banner').fadeOut( "slow" );
        $('#product-overlay__results, .popup-nav__wrapper').html('');

        // Set the Width
        $('.home-hero__wrapper').css({
            "min-width": "",
            "overflow": ""
        });

        // Hide dots from shifting into view
        $('.select-area__dots > div, .flash').css('display', '');
    },

    getResults() {      
        
        // Gets the Area of the selected Dot
        var dataArea = $(this).attr("data-area");
        let area = dataArea;

        $.getJSON(siteData.root_url + '/wp-json/guard/v1/areas', data => {
            // console.log(data[area].map(item => item.title));

            $('#product-overlay__results').html(`
                <div class="pop-up-carousel owl-carousel owl-theme">
                    ${data[area].map(item => `
                        <article class="single__g-product productId-${item.id}">
                            <div class="g-product__wrapper">
                                <div class="content__top flex justify-center items-center bg-guardGray-50 rounded w-full py-6 mb-4">
                                    ${item.image}
                                </div>
                                <div class="content__middle mb-5">
                                    <ul>
                                        <li class="text-xxs font-light mb-1">${item.surface}</li>
                                    </ul>
                                    <p class="font-bold text-sm min-h-[40px]">${item.title}</p>
                                </div>
                                <div class="content__bottom">
                                    <a class="flex items-center justify-center border border-solid border-[#282828] w-[150px] h-[36px] text-xs transition-all hover:bg-guard-blue hover:text-white" href="${item.url}">View Product</a>
                                </div>
                            </div>
                        </article>
                    `).join('')}
                </div>
            `)

            $('.pop-up-carousel').owlCarousel({
                loop:false,
                nav:true,
                responsive:{
                    0:{
                        items:2,
                        margin:16
                    },
                    768:{
                        items:3,
                        margin:24,
                    },
                    1280:{
                        items:4,
                        margin:64
                    },
                    1440:{
                        items:5,
                        margin:80
                    }
                }
            });

            $('.pop-up-carousel .owl-dots').remove();
            $('.pop-up-carousel .owl-nav').appendTo($('.popup-nav__wrapper'));
            $('.popup-nav__wrapper .owl-next span, .popup-nav__wrapper .owl-prev span' ).text('');

        });

    }

    

   
};

export default GetApiData;